/**
 * Human-readable glosses for comparison operators, shared by the readback
 * sentence builder and the plain-English expression outline so both surfaces
 * phrase comparisons identically.
 */
export const READBACK_GLOSSES = {
  '==': 'is',
  '!=': 'is not',
  '>=': 'is at least',
  '<=': 'is at most',
  '>': 'is more than',
  '<': 'is less than',
  contains: 'contains',
  startsWith: 'starts with',
  endsWith: 'ends with',
};
